/**
 * Populate form fields from URL query parameters.
 *
 * Contact Form 7 always sets `wpcf7.cached = 1` when WP_CACHE is enabled
 * (true on this site regardless of whether the page was actually served
 * from cache), and on `window.load` it calls `form.reset()` to guard
 * against stale cached markup. That wipes out anything we set here at
 * DOMContentLoaded, so we populate once immediately (for a same fill on
 * uncached loads) and again after `load` once CF7's reset has run.
 */
document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);

  function populateFormFields() {
    // Build vehicle field value from multiple parameters
    const vehicleParts = [];
    if (urlParams.get("product_year"))
      vehicleParts.push(urlParams.get("product_year"));
    if (urlParams.get("product_make"))
      vehicleParts.push(urlParams.get("product_make"));
    if (urlParams.get("product_model"))
      vehicleParts.push(urlParams.get("product_model"));

    if (vehicleParts.length > 0) {
      const vehicleField = document.querySelector('input[name="vehicle"]');
      if (vehicleField) {
        vehicleField.value = vehicleParts.join(" ");
      }
    }

    // Populate stock number
    const stockNumber = urlParams.get("product_stock_number");
    if (stockNumber) {
      const stockField = document.querySelector('input[name="stock-number"]');
      if (stockField) {
        stockField.value = stockNumber;
      }
    }

    // Populate location (dropdown)
    const location = urlParams.get("product_location");
    if (location) {
      const locationSelect = document.querySelector('select[name="location"]');
      if (locationSelect) {
        // Remove URL encoding artifacts like %2C and +
        const cleanLocation = decodeURIComponent(location).replace(/\+/g, " ");

        // Try to find matching option
        const options = Array.from(locationSelect.options);
        const matchingOption = options.find((opt) => opt.value === cleanLocation);

        if (matchingOption) {
          locationSelect.value = cleanLocation;
        }
      }
    }

    // Populate product URL (hidden field)
    const productUrl = urlParams.get("product_url");
    if (productUrl) {
      const productUrlField = document.querySelector('input[name="product-url"]');
      if (productUrlField) {
        productUrlField.value = decodeURIComponent(productUrl).replace(/\+/g, " ");
      }
    }
  }

  populateFormFields();

  window.addEventListener("load", function () {
    populateFormFields();
  });
});
